document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    freeMode: false,
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // And if we need scrollbar
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: false,
    },
  });

  // Variables para el deslizamiento
  let touchStartX = 0;
  let touchEndX = 0;

  const swipeReceta = document.querySelector('.slide_recetas');
  const swipeContainer = document.querySelector('.swiper');

  // Evento al iniciar el toque
  swipeReceta.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
    console.log('Touch Start X:', touchStartX); // Verifica el punto inicial
  });

  swipeContainer.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
    console.log('Touch Start X:', touchStartX); // Verifica el punto inicial
  });

  // Evento al finalizar el toque
  swipeReceta.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    console.log('Touch End X:', touchEndX); // Verifica el punto final
    handleGesture();
  });

  swipeContainer.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    console.log('Touch End X:', touchEndX); // Verifica el punto final
    handleGesture();
  });

  // Función para manejar el gesto de deslizamiento
  function handleGesture() {
    const swipeThreshold = 50; // Cantidad mínima de píxeles para considerar un swipe

    if (touchEndX < touchStartX - swipeThreshold) {
      // Desliza hacia la izquierda, siguiente slide
      console.log('Swiped left: Next slide');
      document.querySelector('.swiper-button-next').click();
    } else if (touchEndX > touchStartX + swipeThreshold) {
      // Desliza hacia la derecha, slide anterior
      console.log('Swiped right: Previous slide');
      document.querySelector('.swiper-button-prev').click();
    } else {
      console.log('Swipe too short, no action taken');
    }
  }

  const chartDosCarne = document.querySelector('.chart-dos-carne');
  chartDosCarne.classList.add('hidden');
  document.querySelector('.chart-dos-cerdo').classList.add('hidden');
  document.querySelector('.chart-dos-pollo').classList.add('hidden');
  document.querySelector('.recetas-contenedor>.carne').classList.add('active-receta');

  function checkSwiperButtonNext() {
    const swiperButtonNext = document.querySelector('.swiper-button-next');

    if (swiperButtonNext) {
      swiperButtonNext.addEventListener('click', () => {
        const swiperSlideActive = document.querySelector('.swiper-slide-active');

        if (swiperSlideActive.classList.contains('pollo')) {
          // Do something if swiper-slide-active has class 'pollo'
          console.log('Current slide has class "pollo"');
          document.querySelector('.swiper-button-next svg path').setAttribute('fill', '#2FBCAF');
          document.querySelector('.swiper-button-prev svg path').setAttribute('fill', '#2FBCAF');
          document.querySelectorAll('.svg-arrow path').forEach(path => {
            path.setAttribute('fill', '#2FBCAF');
          });
          document.querySelector('.slide_recetas').style.background = '#2FBCAF';
          document.querySelector('.recetas-contenedor>.carne').classList.remove('active-receta');
          document.querySelector('.recetas-contenedor>.cerdo').classList.remove('active-receta');
          document.querySelector('.recetas-contenedor>.pollo').classList.add('active-receta');

        }
        if (swiperSlideActive.classList.contains('carne')) {
          // Do something if swiper-slide-active has class 'pollo'
          console.log('Current slide has class "carne"');
          document.querySelector('.swiper-button-next svg path').setAttribute('fill', '#F58020');
          document.querySelector('.swiper-button-prev svg path').setAttribute('fill', '#F58020');
          document.querySelectorAll('.svg-arrow path').forEach(path => {
            path.setAttribute('fill', '#F58020');
          });
          document.querySelector('.slide_recetas').style.background = '#F58020';
          document.querySelector('.recetas-contenedor>.carne').classList.add('active-receta');
          document.querySelector('.recetas-contenedor>.cerdo').classList.remove('active-receta');
          document.querySelector('.recetas-contenedor>.pollo').classList.remove('active-receta');


        }
        if (swiperSlideActive.classList.contains('cerdo')) {
          // Do something if swiper-slide-active has class 'pollo'
          console.log('Current slide has class "cerdo"');
          document.querySelector('.swiper-button-next svg path').setAttribute('fill', '#95C93D');
          document.querySelector('.swiper-button-prev svg path').setAttribute('fill', '#95C93D');
          document.querySelectorAll('.svg-arrow path').forEach(path => {
            path.setAttribute('fill', '#95C93D');
          });
          document.querySelector('.slide_recetas').style.background = '#95C93D';
          document.querySelector('.recetas-contenedor>.carne').classList.remove('active-receta');
          document.querySelector('.recetas-contenedor>.cerdo').classList.add('active-receta');
          document.querySelector('.recetas-contenedor>.pollo').classList.remove('active-receta');

        }
      });
    }
  }

  checkSwiperButtonNext();


  function checkSwiperButtonPrev() {
    const swiperButtonNext = document.querySelector('.swiper-button-prev');

    if (swiperButtonNext) {
      swiperButtonNext.addEventListener('click', () => {
        const swiperSlideActive = document.querySelector('.swiper-slide-active');

        if (swiperSlideActive.classList.contains('pollo')) {
          // Do something if swiper-slide-active has class 'pollo'
          console.log('Current slide has class "pollo"');
          document.querySelector('.swiper-button-next svg path').setAttribute('fill', '#2FBCAF');
          document.querySelector('.swiper-button-prev svg path').setAttribute('fill', '#2FBCAF');
          document.querySelector('.slide_recetas').style.background = '#2FBCAF';
          document.querySelectorAll('.svg-arrow path').forEach(path => {
            path.setAttribute('fill', '#2FBCAF');
          });
          document.querySelector('.recetas-contenedor>.carne').classList.remove('active-receta');
          document.querySelector('.recetas-contenedor>.cerdo').classList.remove('active-receta');
          document.querySelector('.recetas-contenedor>.pollo').classList.add('active-receta');

        }
        if (swiperSlideActive.classList.contains('carne')) {
          // Do something if swiper-slide-active has class 'pollo'
          console.log('Current slide has class "carne"');
          document.querySelector('.swiper-button-next svg path').setAttribute('fill', '#F58020');
          document.querySelector('.swiper-button-prev svg path').setAttribute('fill', '#F58020');
          document.querySelector('.slide_recetas').style.background = '#F58020';
          document.querySelectorAll('.svg-arrow path').forEach(path => {
            path.setAttribute('fill', '#F58020');
          });
          document.querySelector('.recetas-contenedor>.carne').classList.add('active-receta');
          document.querySelector('.recetas-contenedor>.cerdo').classList.remove('active-receta');
          document.querySelector('.recetas-contenedor>.pollo').classList.remove('active-receta');


        }
        if (swiperSlideActive.classList.contains('cerdo')) {
          // Do something if swiper-slide-active has class 'pollo'
          console.log('Current slide has class "cerdo"');
          document.querySelector('.swiper-button-next svg path').setAttribute('fill', '#95C93D');
          document.querySelector('.swiper-button-prev svg path').setAttribute('fill', '#95C93D');
          document.querySelector('.slide_recetas').style.background = '#95C93D';
          document.querySelectorAll('.svg-arrow path').forEach(path => {
            path.setAttribute('fill', '#95C93D');
          });
          document.querySelector('.recetas-contenedor>.carne').classList.remove('active-receta');
          document.querySelector('.recetas-contenedor>.cerdo').classList.add('active-receta');
          document.querySelector('.recetas-contenedor>.pollo').classList.remove('active-receta');

        }
      });
    }
  }

  checkSwiperButtonPrev()

  function toggleCarne() {
    const chartUnoCarne = document.querySelector('.chart-uno-carne');
    const chartDosCarne = document.querySelector('.chart-dos-carne');

    if (chartUnoCarne.classList.contains('hidden')) {
      chartUnoCarne.classList.remove('hidden');
      chartDosCarne.classList.add('hidden');
    } else {
      chartUnoCarne.classList.add('hidden');
      chartDosCarne.classList.remove('hidden');
    }
  }

  function toggleCerdo() {
    const chartUnoCarne = document.querySelector('.chart-uno-cerdo');
    const chartDosCarne = document.querySelector('.chart-dos-cerdo');

    if (chartUnoCarne.classList.contains('hidden')) {
      chartUnoCarne.classList.remove('hidden');
      chartDosCarne.classList.add('hidden');
    } else {
      chartUnoCarne.classList.add('hidden');
      chartDosCarne.classList.remove('hidden');
    }
  }

  function togglePollo() {
    const chartUnoCarne = document.querySelector('.chart-uno-pollo');
    const chartDosCarne = document.querySelector('.chart-dos-pollo');

    if (chartUnoCarne.classList.contains('hidden')) {
      chartUnoCarne.classList.remove('hidden');
      chartDosCarne.classList.add('hidden');
    } else {
      chartUnoCarne.classList.add('hidden');
      chartDosCarne.classList.remove('hidden');
    }
  }

  const toggleCarneButton = document.querySelector('.toggle-carne');

  toggleCarneButton.addEventListener('click', toggleCarne);

  const toggleCerdoButton = document.querySelector('.toggle-cerdo');

  toggleCerdoButton.addEventListener('click', toggleCerdo);

  const togglePolloButton = document.querySelector('.toggle-pollo');

  togglePolloButton.addEventListener('click', togglePollo);

  const blocks = document.querySelectorAll('.info-right');

  blocks.forEach((block) => {
    // Seleccionar botones dentro del bloque actual
    const buttons = block.querySelectorAll('.btn__banner-con-texto-y-badges');
    const button1 = buttons[0];
    const button2 = buttons[1];

    // Función para intercambiar estilos
    const swapButtonStyles = (btn1, btn2) => {
      const btn1Bg = window.getComputedStyle(btn1).backgroundColor;
      const btn1Color = window.getComputedStyle(btn1).color;
      // Define all possible white color formats
      const whiteColors = [
        'rgb(255, 255, 255)',
        'rgba(255, 255, 255, 1)',
        '#fff',
        '#ffffff',
        'white'
      ];

      // Intercambiar estilos
      btn1.style.backgroundColor = window.getComputedStyle(btn2).backgroundColor;
      btn1.style.color = window.getComputedStyle(btn2).color;
      btn2.style.backgroundColor = btn1Bg;
      btn2.style.color = btn1Color;
      
      // Update z-index based on button background color
      if (whiteColors.includes(window.getComputedStyle(btn1).backgroundColor.toLowerCase())) {
        btn1.style.zIndex = '10';
        btn2.style.zIndex = '';
      } else {
        btn2.style.zIndex = '10';
        btn1.style.zIndex = '';
      }
    };

    // Manejar clic en el primer botón
    button1.addEventListener('click', () => {
      // Mostrar contenido asociado al botón 1 y ocultar el del botón 2
      const chartUno = block.querySelector(`.chart-uno-${block.getAttribute('data-receta-clase')}`);
      const chartDos = block.querySelector(`.chart-dos-${block.getAttribute('data-receta-clase')}`);
      if (chartUno && chartDos) {
        chartUno.classList.remove('tw-hidden');
        chartDos.classList.add('tw-hidden');
      }

      // Intercambiar colores entre los botones
      swapButtonStyles(button1, button2);
    });

    // Manejar clic en el segundo botón
    button2.addEventListener('click', () => {
      // Simular clic en el botón 1
      button1.click();

      // Intercambiar colores entre ambos botones
    });
  });
});